// extracted by mini-css-extract-plugin
module.exports = {"xoLoader":"XoLoader_xoLoader__0PW2o","xoLoader__iconContainer":"XoLoader_xoLoader__iconContainer__NeHgs","fade":"XoLoader_fade__TLNne"};